import { Stack, Typography } from '@mui/material';
import { Tooltip } from '~/components';
import { truncateStyles } from '~/pages/StoragePage/components/styles';

const AnatomyCell = ({ anatomy }: { anatomy: string }) => {
  return (
    <Tooltip
      title={
        <Stack>
          <Typography variant="buttonTextSmall">ANATOMY</Typography>
          <Typography>{anatomy}</Typography>
        </Stack>
      }
    >
      <Typography sx={truncateStyles}>{anatomy}</Typography>
    </Tooltip>
  );
};

export default AnatomyCell;
